export const Paths = {
  root: '/',
  authLogin: '/auth/login',
  templates: '/templates/:collectionId',
  template: '/templates/:collectionId/:id',
  cloneTemplate: '/templates/:collectionId/:id/clone',
  newTemplate: '/templates/:collectionId/new',
};

export const templatePath = (collectionId: string, id: string): string => `/templates/${collectionId}/${id}`;

export const cloneTemplatePath = (collectionId: string, id: string): string => `/templates/${collectionId}/${id}/clone`;

export const templatesPath = (collectionId: string): string => `/templates/${collectionId}`;

export const newTemplatePath = (collectionId: string): string => `/templates/${collectionId}/new`;
